// extracted by mini-css-extract-plugin
export default {"searchForm":"bp_kZ"};